import type { ReactNode } from "react";
import { Icon } from "@sellar-io/components";
import {
  BUSINESS_SETTINGS,
  ORDERS,
  SUPPLIERS,
} from "../../../constants/routes";
import {
  NavigationOverlayBody,
  NavigationOverlayGroup,
} from "./NavigationOverlayLayout";
import { NavigationOverlayRow } from "./NavigationOverlayRow";

export const BusinessNavigationOverlayContent = ({
  businessName,
  companyName,
  invitation,
  onSwitchBusiness,
}: {
  businessName: string;
  companyName?: string;
  invitation?: ReactNode;
  onSwitchBusiness: () => void;
}) => (
  <NavigationOverlayBody className="gap-0">
    <NavigationOverlayRow
      variant="identity"
      autoFocus
      onClick={onSwitchBusiness}
      trailing={
        <Icon icon="SWAP_VERTICAL" size="24px" className="text-[#8c23c7]" />
      }
      leading={
        <span className="flex size-11 items-center justify-center rounded-full bg-purple-100 text-purple-700">
          <Icon icon="STOREFRONT_OUTLINE" size="24px" />
        </span>
      }
      description={companyName}
      titleClassName="text-base leading-6 font-semibold"
      descriptionClassName="text-sm leading-5"
      className="cursor-pointer rounded-none border-b border-zinc-200 bg-zinc-50 p-5 [&>span]:break-words [&>span:first-child]:size-11"
    >
      {businessName}
    </NavigationOverlayRow>
    <div className="p-4">
      <NavigationOverlayGroup>
        <NavigationOverlayRow
          className="text-zinc-700"
          to={BUSINESS_SETTINGS}
          leading={<Icon icon="COG_OUTLINE" size="16px" />}
          trailing={
            <Icon icon="CHEVRON_RIGHT" size="16px" className="text-zinc-500" />
          }
        >
          Business settings
        </NavigationOverlayRow>
        <NavigationOverlayRow
          className="text-zinc-700"
          to={SUPPLIERS}
          leading={<Icon icon="ACCOUNT_MULTIPLE_OUTLINE" size="16px" />}
          trailing={
            <Icon icon="CHEVRON_RIGHT" size="16px" className="text-zinc-500" />
          }
        >
          My Suppliers
        </NavigationOverlayRow>
        <NavigationOverlayRow
          className="text-zinc-700"
          to={ORDERS}
          leading={<Icon icon="CART_OUTLINE" size="16px" />}
          trailing={
            <Icon icon="CHEVRON_RIGHT" size="16px" className="text-zinc-500" />
          }
        >
          Order history
        </NavigationOverlayRow>
      </NavigationOverlayGroup>
    </div>
    {invitation}
  </NavigationOverlayBody>
);
